import type { HekateDisplayForm } from '@onshape/www-inertia';
import type { Ref } from 'vue';
import { toRefs, watch } from 'vue';
import CommonPreFilledProgressiveProfile from './CommonPreFilledProgressiveProfileDefinition';
import { buildAgeVerificationField } from '../../coordinator/AgeVerificationFieldCoordinator';

export default class UnifiedSignupProgressProfile extends CommonPreFilledProgressiveProfile {
  public override realtimeBranchModifications({
    formDefinition,
  }: {
    formDefinition: Ref<HekateDisplayForm>;
  }): void {
    super.realtimeBranchModifications({ formDefinition }); // handles edu country/region, etc...

    formDefinition.value.displayFields.push(buildAgeVerificationField());

    const { screenNumber } = toRefs(formDefinition.value);
    watch(screenNumber, () => {
      console.log('Screen number', screenNumber.value);
    });
  }
}
